export default __webpack_public_path__ + "static/media/EricHungNguyen.c95028d4.png";